module.exports = __webpack_public_path__ + "static/img/snip3down.34c051e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/image-benefit/snip3down.png
// module id = 4BU4
// module chunks = 35